import styled, { css } from 'styled-components';

import { gridSizes, media, textSizes, weights } from 'utils/style';

import QuotePrice from 'components/Price/component';
import PriceSuggest from 'components/Price/PriceSuggest';

const totalContainerStyles = css`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  width: 32rem;
  position: fixed;
  overflow: auto;
  max-height: calc(100vh - 71.55px); //header
  padding-bottom: 5rem;
  ${media.lessThan('large')`
    position: static;
    padding-bottom: 0;
    overflow: unset;
 `}
  & h1 {
    ${media.lessThan('large')`
      margin: 0;
    `}
  }

  .total-container {
    outline: 3px red solid;
  }

  .fixed-heigth-component  {
    background-color: white;
    ${media.lessThan('large')` 
      border-top: 1px solid #E2E8EE;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      order: 2;
    `}
    ${media.lessThan('small')`
      display: block;
    `}
    .loadWrap {
      ${media.lessThan('large')`
          justify-content: space-between;
          align-items: start;
          flex-direction: column;
          padding: 16px 24px 24px;
          width: auto;
        `}
      ${media.lessThan('small')`
          position: relative;
          padding: 10px 24px 0;
          gap: 5px; 
          width: 100%;
          align-items: center;
        `}
    }
  }
`;

const priceContainerStyles = css``;

const buttonActionStyles = css`
  .form-button-container {
    ${media.lessThan('large')`
      grid-column: 2;
      margin-left: auto;
      margin-top: auto;
      padding: 16px 24px 24px;
      width: fit-content;
    `}
    ${media.lessThan('small')`
      border-top: 1px solid #CCD6E0;
      width: 100%;
    `}
  }
  button {
    width: 100%;
    ${media.lessThan('large')`
      width: auto;
    `}
    ${media.lessThan('small')`
    width: 100%;
    margin-left: auto;
  `}
  }
`;

const alertMessages = css`
  .button-msg-error {
    background: #fedbdb;
    border: 1px solid red;
    color: black;
    & svg path {
      fill: red;
    }
  }
  .button-msg-warning {
    background: #fff2e0;
    border: 1px solid #fcc475;
    & svg path {
      fill: #e37012;
    }
  }
  .button-msg-error,
  .button-msg-warning {
    border-radius: 4px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    padding: 2rem 16px 8px;
    margin-top: 25px;
    & svg {
      display: block;
      margin: 0 auto;
      min-width: 20px;
      min-height: 20px;
    }
    ${media.lessThan('large')`
    order: 1;
    display: flex;
    align-items: start;
    border: none;
    border-radius: 0px;
    margin: 0;
    padding: 16px 24px;
    color: #263340;
    font-weight: 400;
    & svg {
      margin: 0 10px 0 0;
    }
    & p {
      margin: 0;
    }
    `}
  }
`;

const vatStyles = css`
  .price-container {
    display: flex;
    align-items: baseline;
    &.collapsable {
      padding: ${gridSizes('M')} 0;
      ${media.lessThan('large')`
        flex-direction: column;
        padding: 16px 24px 10px;
    `}
      ${media.lessThan('small')`
      flex-direction: row;
      justify-content: space-between;
    `}
    }

    & svg {
      display: none;
      ${media.lessThan('large')`
       display: block; 
       cursor: pointer;
      `}
    }
  }

  .price-literal-container {
    order: 1;
    &.collapsable {
      ${media.lessThan('large')`
      display: flex;
      align-items: center;
      > div:first-child{
        margin-right: ${gridSizes('S')};
      }
    `}
    }
    ${media.lessThan('small')`
      max-width: 15rem;
    `}
  }

  .price-literal {
    font-size: ${textSizes('XXL')};
    color: var(--grey900);
    font-weight: ${weights('medium')};
    ${media.lessThan('small')`
    
    `}
  }

  .vat-literal {
    margin-right: ${gridSizes('M')};
    font-weight: ${weights('medium')};
  }
`;

export default styled(QuotePrice)`
  ${totalContainerStyles}
  ${priceContainerStyles}
  ${buttonActionStyles}
  ${alertMessages}
  ${vatStyles}
`;

export const PriceSuggestStyled = styled(PriceSuggest)`
  > div {
    width: 100%;
    text-align: center;
  }
  display: inherit;
  ${media.lessThan('large')`
    display: none;
  `};
`;
